<!-- 
程式：familyAddCust.vue
功能：群組歸戶列表
作者：i9400539 鄧?擇
完成：2020-07-30
-->
<template>
  <main
    class="body-container custMain"
    :style="isBox ? 'top: 0px;' : ''"
    @scroll="scrollmethod"
  >
    <section class="search container-fluid" style="padding: 20px 16px">
      <div class="row">
        <div class="col-12">
          <h3 class="text-green">加入家戶成員</h3>
          <div
            class="label"
            style="font-size: 18px; font-weight: 600; margin: 17px 0px"
          >
            請選擇您想加入
            <span
              class="text-green"
              style="cursor: pointer"
              @click="routeToCustDetail(homeLeader.csidno, homeLeader.name)"
            >
              {{ homeLeader.name | truncate }}
            </span>
            的家戶的成員
          </div>
        </div>
        <div class="col-12">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="currentKeyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名、身分證進行搜尋..."
                  alt="ch"
                  maxlength="40"
                  @input="checkCurrentKeyword"
                />
                <span
                  id="searchclear"
                  v-show="currentKeyword"
                  @click="clearSearch()"
                >
                  清除
                </span>
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <section class="search container-fluid">
      <div class="radio radio-inline">
        <input type="radio" v-model="isShowAll" id="isRelate-Y" :value="true" />
        <label for="isRelate-Y">全部</label>
      </div>
      <div class="radio radio-inline">
        <input
          type="radio"
          v-model="isShowAll"
          id="isRelate-N"
          :value="false"
        />
        <label for="isRelate-N">已選擇({{ selection.length }})</label>
      </div>
    </section>

    <section
      class="search container-fluid"
      style="padding-left: 6px; padding-right: 6px"
    >
      <!-- <div class="row newTable">
        <section class="w-100">
          <table id="" class="table datatable table-striped insurance-green">
            <thead>
              <tr>
                <th>
                  <div class="checkbox checkbox-inline mr-0">
                    <input
                      type="checkbox"
                      id="check-all"
                      v-model="isAllChecked"
                    /><label for="check-all"></label>
                  </div>
                  <span>#</span>
                </th>
                <th
                  class="sorting"
                  :class="getSortClassName('name')"
                  @click="changeSort('name')"
                >
                  <span>姓名</span>
                </th>
                <th
                  class="sorting"
                  :class="getSortClassName('id')"
                  @click="changeSort('id')"
                >
                  <span>身分證</span>
                </th>
                <th
                  class="sorting"
                  :class="getSortClassName('mobile')"
                  @click="changeSort('mobile')"
                >
                  <span>手機</span>
                </th>
                <th
                  class="sorting"
                  :class="getSortClassName('phone')"
                  @click="changeSort('phone')"
                >
                  <span>電話</span>
                </th>
                <th
                  class="sorting"
                  :class="getSortClassName('birthday')"
                  @click="changeSort('birthday')"
                >
                  <span>生日</span>
                </th>
                <th
                  class="sorting test"
                  :class="getSortClassName('address')"
                  @click="changeSort('address')"
                >
                  <span>住家地址</span>
                </th>
              </tr>
            </thead>
            <tbody v-if="isLoading">
              <tr>
                <td colspan="8" class="empty-block">
                  <h3>
                    <div
                      class="section-loading d-inline-block"
                      style="height: 20px; width: 30px"
                    ></div>
                    資料讀取中，請稍候...
                  </h3>
                </td>
              </tr>
            </tbody>
            <tbody class="block-height" v-else-if="proccessDatas.length">
              <tr v-for="(data, index) in proccessDatas" :key="index">
                <td height="30">
                  <div class="mr-0 checkbox checkbox-inline">
                    <input
                      type="checkbox"
                      :id="'check-' + index"
                      v-model="data.checked"
                    /><label :for="'check-' + index"></label>
                  </div>
                  <span class="no">{{ index + 1 }}</span>
                  <span class="info text-center">
                    <avatar :gender="+data.sex" :size="20" />
                  </span>
                </td>
                <td><truncate-tool :content="data.name"></truncate-tool></td>
                <td>{{ data.id || "— —" }}</td>
                <td>{{ data.mobile || "— —" }}</td>
                <td>{{ data.phone || "— —" }}</td>
                <td>
                  <div class="date">
                    {{ data.birthday | dateToROCdateFormat }}
                  </div>
                </td>
                <td>{{ data.address || "— —" }}</td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td colspan="8" class="empty-block">
                  <h3>查無資料，請確認您輸入之資料是否正確</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>-->
      <div class="container-fluid">
        <div class="row">
          <!-- kerry test -->
          <data-table
            style="width: 100%"
            @update="updateSelection"
            :selection="selection"
            :currentPage="paginate.page"
            :table-data="proccessDatas"
            :options="tableOption"
            :initSort="initSort"
            :remote-data-msg="remoteDataMsg"
            :addPageStatus="addPageStatus"
            :dataLoading="isLoading"
            :isMask="true"
          />
        </div>
      </div>
    </section>

    <fixed-botton ref="fixedBtn">
      <template slot="@function">
        <button
          type="button"
          class="btn btn-default btn-custStyle mr-3"
          @click="goBack('familyRelation')"
        >
          取消
        </button>
        <button
          type="button"
          class="btn btn-primary btn-custStyle"
          @click="goAddFamily()"
          :disabled="!selection.length > 0"
        >
          下一步
        </button>
      </template>
    </fixed-botton>
  </main>
</template>

<script>
import DataTable from "@/desktop/views/mv/components/DataTable/DataTableScroll";

import FixedBotton from "./components/modal/fixedBotton";
import { mapActions } from "vuex";
import { queryRelationList } from "@/service";
import Avatar from "@/components/Avatar";
import RouteToCustDetailMixins from "@/mixins/RouteToCustDetail";
import { commonMixin } from "@/mixins/common";
import TruncateTool from "@/desktop/views/mv/PolicyInfo/components/TruncateTool";
const { _ } = window;

export default {
  mixins: [RouteToCustDetailMixins, commonMixin],
  components: {
    FixedBotton,
    Avatar,
    TruncateTool,
    DataTable,
  },
  data() {
    const querySort = {
      order_by: this.$route.query.order_by || "7",
      colName: this.$route.query.colName || "address",
      isSort: this.$route.query.isSort == "true" || false,
    };
    return {
      homeLeader: {},
      isLoading: false,
      isShowAll: true,
      datas: [],
      paginate: {
        page: 0, //當前頁數
        perPage: 200,
        total: {
          all: 0, //所有客戶總頁數
          no: 0, //尚未歸戶總頁數
        },
      },
      // 顯示關鍵字
      currentKeyword: "",
      // 實際過濾關鍵字
      keyword: "",
      // 排序
      sort: {
        key: "name",
        type: "asc",
      },
      remoteDataMsg: "查無資料", //讀取訊息
      selection: [], // 勾選項目

      addPageStatus: false,
      initSort: false,
      tableOption: {
        showAge: true,
        checkAll: true,
        checkList: true,
        scrollHeight: 478,
        noScroll: false,
        checkBoxHasUser: true,
        truncate: true,
        columns: [
          {
            width: 150,
            name: "name",
            label: "姓名",
            sorting: true,
            click: (data) => {
              this.routeToCustDetail2(data.id, data.ser_no, data.name);
            },
          },
          {
            width: 120,
            name: "showid",
            label: "身分證",
            sorting: true,
          },
          {
            width: 120,
            name: "mobile",
            label: "手機",
            sorting: true,
          },
          {
            width: 130,
            name: "phone",
            label: "電話",
            sorting: true,
          },
          {
            width: 100,
            name: "birthday",
            label: "生日",
            sorting: true,
          },
          {
            name: "address",
            sorting: true,
            label: "住家地址",
          },
        ],

        // 排序
        defaultSort: {
          colName: querySort.colName,
          asc: querySort.isSort,
          doSort: false,
        },
        sorting: this.changeSort,
      }, // table參數
    };
  },
  watch: {
    // 清除關鍵字
    currentKeyword(newVal) {
      if (!newVal) {
        this.clearSearch();
      }
    },
    // 顯示全部
    isShowAll() {
      this.clearSearch();
    },
  },
  methods: {
    ...mapActions(["updateLastFamilyResult", "updateFamilyResultFilter"]),
    checkCurrentKeyword() {
      this.currentKeyword = this.cleanSpecialChar(this.currentKeyword);
      if (this.stringBytes(this.currentKeyword, false, 40) > 40) {
        this.currentKeyword = this.currentKeyword.substring(0, this.stringBytes(this.currentKeyword, true, 40));
      }
    },
    getSortClassName(key) {
      if (this.sort.key == key) {
        return `sorting_${this.sort.type}`;
      }
      return "";
    },
    changeSort(key) {
      this.sort.type =
        this.sort.key !== key
          ? "asc"
          : this.sort.type == "asc"
          ? "desc"
          : "asc";
      this.sort.key = key;
    },
    clearSearch() {
      this.keyword = this.currentKeyword = "";
    },
    updateSelection(val) {
      this.selection = val;
    },
    doSearch() {
      this.keyword = this.currentKeyword;
    },
    // 取得客戶列表
    async getDatas(agntId) {
      this.isLoading = true;
      const reqBody = [agntId, "", "1", "1", "1", "1", "1", "1", "2", "1"];
      const res = await queryRelationList(...reqBody);
      this.datas =
        res.body.noFamilyList.map((x, i) => ({
          ...x,
          // 索引
          guid: i,
          csidno: x.id || x.ser_no,
          birthday: x.birthday ? x.birthday : "",
          checked: false,
        })) || [];
      this.paginate.total = this.datas.length;
      this.isLoading = false;
    },
    scrollmethod(e) {
      // ----滾動顯示/隱藏----
      this.$refs.fixedBtn.scrollEvent();
      if (
        // 滾到底
        e.srcElement.scrollTop + e.srcElement.offsetHeight >
          e.srcElement.scrollHeight - 100 &&
        // 顯示數量是否大於全部
        this.paginate.perpage < this.paginate.total
      ) {
        // 顯示數量增加200
        this.paginate.perpage += 200;
      }
    },
    // 取得戶長資訊
    getHomeLeader() {
      this.homeLeader = JSON.parse(localStorage.userItems);
      if (!this.homeLeader.csidno) {
        this.goBack("allHolder");
        this.$toast.info({ title: "無戶長資訊" });
      }
    },
    goAddFamily() {
      let checkDatas = this.selection ? this.selection.length : 0;
      let allFamilyNumber = this.$route.params.allFamilyNumber
        ? this.$route.params.allFamilyNumber
        : 0;
      let checkCount = checkDatas + allFamilyNumber;
      if (checkCount > 50) {
        this.$toast.info({ title: "家戶成員不得超過50人+" });
        return;
      }
      this.updateFamilyResultFilter(this.selection);
      this.updateLastFamilyResult([]);
      this.$router.push({
        name: "checkAddFamily",
        params: { selectedHolder: this.homeLeader.csidno },
      });
    },
    goBack(defaultPath) {
      let backTo = this.getHistory("familyAddCust");
      this.$router.push({
        name: backTo ? backTo : defaultPath,
      });
    },
  },
  computed: {
    datasKeyByIndex() {
      return _.keyBy(this.datas, "guid");
    },
    proccessDatas() {
      const keywordFilter = this.keyword
        ? (x) =>
            ["name", "id", "phone", "mobile", "address"].some((prop) =>
              (x[prop] || "").includes(this.keyword)
            )
        : () => true;
      const res = !this.isShowAll > 0 ? _(this.selection) : _(this.datas);
      return res
        .map((e) => {
          return { ...e, showid: e.id };
        })
        .filter(keywordFilter)
        .orderBy(this.sort.key, this.sort.type)
        .value();
    },
    isBox() {
      //判斷是否為box   this.UserInfo.userType === 'box'
      return this.UserInfo.userType === "box";
    },
    /*
    isAllChecked: {
      get() {
        return this.proccessDatas.every((x) => x.checked) && this.checkedCount;
      },
      set(val) {
        const datasKeyByIndex = _.cloneDeep(this.datasKeyByIndex);
        // 畫面上(已選擇)的才更新
        this.proccessDatas.forEach(
          (x) => (datasKeyByIndex[x.guid].checked = val)
        );
        this.datas = _.map(datasKeyByIndex);
      },
    },

    checkedDatas() {
      return this.datas.filter((x) => x.checked);
    },
   
    checkedCount() {
      return this.checkedDatas.length;
    },
    */
  },
  mounted() {
    this.getHomeLeader();
    this.getDatas(this.$store.state.userInfo.id);
    this.tableOption.scrollHeight =
      $(window).height() - 510 < 450 ? 450 : $(window).height() - 510;
    let self = this;

    $(window).on("resize", function () {
      self.$nextTick(() => {
        self.tableOption.scrollHeight =
          $(window).height() - 510 < 450 ? 450 : $(window).height() - 510;
      });
    });
  },
};
</script>

<style lang="scss"  scoped>
#searchclear {
  position: absolute;
  right: 20px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}

::placeholder {
  line-height: normal;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.body-container {
  position: fixed;
  top: 6rem;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}

.btn-custStyle {
  padding-top: 9px !important;
  width: 120px;
  height: 40px;
}
.custMain {
  padding-top: 0px !important;
  padding-bottom: 110px;
}
</style>
